import { ContentModel } from "@app/main/content/game-settings/popup/content/content.model";

export class PopupModel {
  type?: string;
  data?: any;
  content?: ContentModel = new ContentModel();
  timer?: any;
  position?: number;

  constructor(popup?: PopupModel) {
    this.type = popup && popup.type ? popup.type : "";
    this.data = popup && popup.data ? popup.data : undefined;
    this.content = popup && popup.content ? popup.content : new ContentModel();
    this.timer = popup && popup.timer ? popup.timer : "0";
    this.position = popup && popup.position ? popup.position : 0;
  }
}
